<template>
  <div
    class="
      surface-ground
      flex
      align-items-center
      justify-content-center
      min-h-screen min-w-screen
      overflow-hidden
      fullScreen
    "
  >
    <div class="flex flex-column align-items-center justify-content-center">
      <div
        style="
          border-radius: 56px;
          padding: 0.3rem;
          background: linear-gradient(
            180deg,
            rgba(0, 200, 255, 0.4) 10%,
            rgba(247, 149, 48, 0) 30%
          );
        "
      >
        <div
          class="
            w-full
            surface-card
            py-8
            px-5
            sm:px-8
            flex flex-column
            align-items-center
          "
          style="border-radius: 53px"
        >
          <div class="grid flex flex-column align-items-center">
            <div
              class="
                flex
                justify-content-center
                align-items-center
                bg-blue-400
                border-circle
              "
              style="width: 3.2rem; height: 3.2rem"
            >
              <i class="text-50 pi pi-fw pi-lock text-2xl"></i>
            </div>
            <h1 class="text-900 font-bold text-4xl lg:text-5xl mb-2">
              Acesso Negado
            </h1>
            <span class="text-600 mb-5"
              >Você não tem permissão para acessar esta página. Entre em contato
              com o Administrador so sistema!</span
            >
            <div class="col-12 mt-5 text-center">
              <a :href="$UrlIntranet" class="link-custom hvr-backward">
                <span
                  ><i class="pi pi-arrow-circle-left" style="font-size: 1.6rem"
                /></span>
                Voltar
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
</script>

<style lang="scss" scoped>
@import "../external/components/styles.scss";
</style>